import { useSearchParams, useParams, Link } from "react-router-dom";

import { ComponentsWorkflowStep } from "../components/components-step/ComponentsWorkflowStep";
import { AppShell } from "../components/shell/Shell";
import type { ComponentType } from "../types/components";

const VALID: ComponentType[] = ["module", "inverter", "tracker"];

function parseType(raw: string | null): ComponentType {
  if (!raw) return "module";
  // Accept singular ("module") or plural ("modules") query values.
  const trimmed = raw.replace(/s$/, "") as ComponentType;
  return VALID.includes(trimmed) ? trimmed : "module";
}

/**
 * /projects/:id/components?type=modules|inverters|trackers
 *
 * Form-mode page per ``docs/ui-architecture.md``. No canvas. No map.
 */
export function ComponentsPage() {
  const { id } = useParams<{ id: string }>();
  const [params, setParams] = useSearchParams();
  const componentType = parseType(params.get("type"));

  if (!id) {
    return (
      <AppShell width="wide">Project ID missing.</AppShell>
    );
  }

  return (
    <AppShell width="wide">
      <div data-testid="components-page">
        <Link to={`/projects/${id}`} data-testid="components-page-back">
          ← Back to project
        </Link>
        <h1 style={{ margin: "0.5rem 0 1rem" }}>Components</h1>
        <ComponentsWorkflowStep
          projectId={id}
          componentType={componentType}
          onChangeType={(next) => {
            const sp = new URLSearchParams(params);
            sp.set("type", `${next}s`);
            setParams(sp, { replace: true });
          }}
        />
      </div>
    </AppShell>
  );
}
